import React from 'react';
import { SiderParentLabel, SiderItem } from "./";


export const SupervisorSide = () => {

    const NAV_ITEMS = [
        {
            route: "/supervisor/agents-status",
            icon: "bi bi-person-circle",
            label: "Agents Status"
        },
        {
            route: "/supervisor/intervention",
            icon: "bi bi-clock-history",
            label: "Interventions Status"
        }
    ]

    return (
        <>
            <SiderParentLabel icon="bi bi-briefcase-fill" label="Supervisor Part" />
            {NAV_ITEMS.map((item) => <SiderItem {...item} />)}
        </>
    );
}